import TwoFactorVerification from './Screen/TwoFactorVerification';

export default TwoFactorVerification;

